module.exports = __webpack_public_path__ + "static/me-b93b9eb92ca6d145b34e22aa970707d0.png";